window.addEventListener("load", (event) => {
  $(".template-index .wrap .flickity-page-dots").each(function(index){
    console.log($(this));
    if($(this).is(':empty'))
        $(this).parent().parent().parent().hide();
  });
});

/*document.getElementById('frame_FZPd-mavR_tkkZgQ9kelsA').onload= function() {
  let body = $(this).contents().find("body");
  setTimeout(function(){
    alert("hola4");
    let css = '<style type="text/css"> div#wizard-validation-form h3, div#wizard-validation-form .form_title_div { font-size: 20px !important; text-align: center !important; font-family: Raleway !important; font-weight: 700 !important; letter-spacing: 0 !important; color: #000 !important; } .block_label { letter-spacing: 0 !important; color: #000 !important; } </style>';
    jQuery(body).append(css);
  },1000);
};*/
